
















import { Component, Vue } from "vue-property-decorator";

import { Getter } from "vuex-class";

declare global {
  interface InputEvent extends Event {
    readonly inputType: string;
  }
}

@Component
export default class Uploader extends Vue {
  @Getter private JWT!: string;
  @Getter private UID!: string;
  private openFilePicker() {
    let filePicker = this.$refs.fileInput as HTMLInputElement;
    filePicker.click();
  }
  private showSuccessToast() {
    this.$bvToast.toast(
      "File is being processed. You will receive an email when results are ready.",
      {
        noCloseButton: true,
        variant: "success",
        autoHideDelay: 2000,
        solid: true,
      }
    );
  }
  private showErrorToast(errorMessage: string) {
    this.$bvToast.toast(errorMessage, {
      noCloseButton: true,
      variant: "danger",
      autoHideDelay: 2000,
      solid: true,
    });
  }

  async uploadFile(event: InputEvent) {
    const file = (event.target as HTMLInputElement).files![0];
    if (!file) return;

    if (file.size > 100 * 1024 * 1024) {
      this.showErrorToast("File size exceeds the limit of 100MB.");
      return;
    }

    const video = document.createElement("video");
    video.src = URL.createObjectURL(file);
    await new Promise<void>((resolve) => {
      video.onloadedmetadata = () => {
        const { duration } = video;
        URL.revokeObjectURL(video.src);

        if (duration > 3600) {
          this.showErrorToast("Video duration exceeds the limit of 1 hour.");
        } else {
          this.uploadToServer(file);
        }

        resolve();
      };
    });
  }

  async uploadToServer(file: File) {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await fetch(
        `https://oraiappv2.tryoratio.com/mobileapp/v2/user/${this.UID}/upload-speech`,
        {
          method: "POST",
          headers: {
            Authentication: this.JWT,
          },
          body: formData,
        }
      );

      if (response.ok) {
        this.showSuccessToast();
      } else {
        alert("Failed to upload file.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("An error occurred while uploading the file.");
    }
  }
}
